import gql from 'graphql-tag'

import apolloClient from '@/vendor/apollo'

export function getUser (id) {
  return apolloClient.query({
    query: gql`
      query GetUser ($id: Int!) {
        user (id: $id) {
          id: _id
          avatar_url
          is_followed
          name
          nickname,
          is_performance_leader,
          is_my_management_scope
        }
      }
    `,
    variables: {
      id
    }
  }).then(res => res.data.user)
}
